export default {
  create
};

function create(payment, generationTime) {
  return new Promise((resolve, reject) => {
    if (payment && generationTime) {
      try {
        const cardData = {
          number: payment.cardNumber,
          cvc: payment.securityCode,
          holderName: payment.name,
          expiryMonth: payment.month,
          expiryYear: payment.year,
          generationtime: generationTime
        };
        const cseInstance = window.adyen.createEncryption({});
        const cardEncrypted = cseInstance.encrypt(cardData);
        resolve(cardEncrypted);
      } catch (e) {
        reject('Unable to load data from adyen service');
      }
    } else {
      reject('Incomplete data sent to Adyen');
    }
  });
}



// WEBPACK FOOTER //
// ./src/services/adyen/AdyenService.js